import en from "@/lang/en.json";
import fr from "@/lang/fr.json";
import {merge} from "lodash";
import router from "@/router";

const state = {};
const getters = {
	/**
	 * Retrieves the current language setting from the query parameters of the router's current route.
	 * If no language is specified in the query, it defaults to 'en'.
	 *
	 * @return {string} The language code from the router's query parameters or 'en' as the default.
	 */
	language() {
		return router?.currentRoute?.query?.language || 'en';
	},
	/**
	 * Provides the merged language configuration based on the current state and settings.
	 *
	 * @param {Object} state - The local module state.
	 * @param {Object} getters - The local module getters.
	 * @param {Object} rootState - The root state of the Vuex store.
	 * @param {Object} rootGetters - The root getters of the Vuex store.
	 * @return {Object} The merged language configuration object.
	 */
	lang(state, getters, rootState, rootGetters) {
		const dict = {en, fr};
		const config = rootGetters['config/settings'];
		const zone = String(rootGetters['flyer/zone']).toLowerCase();


		// Language override based on zone as "zone-<zone>"
		const zoned = config?.lang?.[`zone-${zone}`] || {};

		// Language Override based on zone + language as "zone-<zone>-<language>"
		const zonedLang = config?.lang?.[`zone-${zone}-${getters.language}`] || {};

		let o = merge(dict[getters.language], (config?.lang || {})[getters.language]);

		o = merge(o, zoned);
		o = merge(o, zonedLang);

		return o
	},
};
const actions = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
};
